import styles from "@/styles/Process.module.scss";
import ProcessInformation from "@/components/ProcessInformation";
import { Robots } from "@/components/MetaTags/index";
import config from "@/lib/config";

export default function GeoRestriction() {
  return (
    <>
      <Robots content="noindex" />
      <ProcessInformation header="ご利用の地域では、本サービスをご利用いただけません。">
        <div className={styles.information}>
          <p>
            本サービスは、日本国内でのみ利用を許可されているサービスです。
            <br />
            日本国外からのご利用はできませんので、ご了承くださいますようお願い申し上げます。{" "}
            <br />
            国内で利用いただいていてこの画面が出る場合はしばらくたってから再度お試しいただくか、
            <br />
            他のデバイス・ネットワーク環境からお試しください。
            <br />
            <br />
            地域判定エラーについてのヘルプはこちら
            <br />
            <a
              href={config.staticLinks.geoRestriction}
              className={styles.linkText}
            >
              {config.staticLinks.geoRestriction}
            </a>
          </p>
        </div>
      </ProcessInformation>
    </>
  );
}
GeoRestriction.layout = "NoHeaderLayout";
// GeoRestriction.noTransition = true;
